import { render, staticRenderFns } from "./ComboSliderCard.vue?vue&type=template&id=f8f10ba0&"
import script from "./ComboSliderCard.vue?vue&type=script&lang=js&"
export * from "./ComboSliderCard.vue?vue&type=script&lang=js&"
import style0 from "./ComboSliderCard.vue?vue&type=style&index=0&id=f8f10ba0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports